module.exports = __webpack_public_path__ + "static/media/LegoJungleBattleAreaINTA0016_design_clean_v002.c4a8403d.png";